import React from "react";
import styles from "./FieldDescription.less";
import cx from "classnames";
export function FieldDescription(props) {
  return props.description ? React.createElement("p", {
    className: styles.Description
  }, props.description) : null;
}